// Deterministic, realistic-looking French customer reviews per product.
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

const NAMES = [
  "Camille D.", "Julien M.", "Sophie L.", "Thomas B.", "Léa R.", "Nicolas P.",
  "Manon G.", "Alexandre F.", "Chloé V.", "Maxime T.", "Emma C.", "Hugo N.",
  "Sarah K.", "Antoine D.", "Inès B.", "Lucas M.", "Clara S.", "Romain L.",
  "Océane P.", "Kévin H.", "Mélanie J.", "Adrien C.", "Laura F.", "Quentin R.",
];

const TEXTS = [
  "Livraison rapide et produit conforme à la photo. Effet garanti pour ma soirée, tout le monde a adoré !",
  "Super qualité pour le prix, je ne m'attendais pas à ça. Mes invités ont été bluffés le soir d'Halloween.",
  "Exactement ce que je cherchais pour décorer la maison. Rendu vraiment flippant, top !",
  "Commandé mardi, reçu vendredi. Emballage soigné et article nickel. Je recommande la boutique.",
  "Parfait ! Mes enfants étaient fous de joie. On va sûrement recommander d'autres articles.",
  "Très bon rapport qualité-prix. L'effet est encore mieux en vrai que sur les photos.",
  "Petit coup de cœur, ça rend super bien dans le salon. Merci pour l'envoi rapide.",
  "Article solide et bien fini. Utilisé pour ma déco de porche, les voisins ont adoré.",
  "Rien à redire, conforme et livré dans les temps. Idéal pour préparer Halloween à l'avance.",
  "Effet garanti pour faire peur ! Fabrication correcte, je suis satisfaite de mon achat.",
  "Je recommande les yeux fermés. Produit reçu rapidement et parfaitement emballé.",
  "Vraiment top pour le prix. J'ai repris le code promo, c'était une super affaire.",
  "Qualité au rendez-vous, l'ambiance était parfaite pour notre fête. On adore !",
  "Conforme à la description, envoi soigné. Petit plus : le rendu la nuit est bluffant.",
  "Achat validé, tout est parfait. La boutique répond vite aux questions, service au top.",
];

const STAR_POOL = [5, 5, 5, 4, 5, 5, 4, 5];

function daysAgoDate(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
}

export function getReviews(slug) {
  const h = hash(slug);
  const ratingChoices = [4.6, 4.7, 4.8, 4.9];
  const rating = ratingChoices[h % ratingChoices.length];
  const count = 42 + (h % 210);
  const items = [];
  const n = 3 + (h % 2); // 3 or 4 reviews
  for (let i = 0; i < n; i++) {
    const idx = (h + i * 7) % TEXTS.length;
    const nameIdx = (h + i * 5) % NAMES.length;
    const stars = STAR_POOL[(h + i * 3) % STAR_POOL.length];
    items.push({
      name: NAMES[nameIdx],
      text: TEXTS[idx],
      stars,
      date: daysAgoDate(3 + ((h + i * 11) % 55)),
      verified: true,
    });
  }
  return { rating, count, items };
}
